{{#each items}}
    {{#if isValid}}
        {{#unless isTemplated }}
            {{#if canUploadFiles }}
                {{#unless printFiles.length}}
                    {{#unless fileSessionId}}
                        <div class="collaterateInfo-message isInfo isInfo_cart">
                            <p class="collaterateInfo-message-bd">Cart Item needs print files: <span class="collaterateInfo-message-bd-itemName"> {{name}}</span></p>
                        </div>
                    {{/unless}}
                {{/unless}}
                {{#if fileSessionId}}
                    {{#if initialized}}
                        {{#unless fileSessionCount}}
                            <div class="collaterateInfo-message isInfo isInfo_cart">
                                <p class="collaterateInfo-message-bd">Cart Item needs print files: <span class="collaterateInfo-message-bd-itemName"> {{name}}</span></p>
                            </div>
                        {{/unless}}
                    {{/if}}
                {{/if}}
            {{/if}}
        {{/unless}}
    {{/if}}
{{/each}}
